

define(['angular', 'text!./template.html'], function (angular, template) {

    return angular.module('xo-add-card.selectcard.directive', []).directive('xoSelectCard', function () {

        return {
            template: template,

            scope: {
                parentCallbacks: '=',
                token: '=',
                promotion: '='
            },

            controller: function controller($scope, $populate, $CheckoutSessionModel) {

                $populate($scope, {
                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
                }).then(function () {
                    $scope.selectCardType = function (type) {
                        // card type is either 'cc' or 'plcc'
                        $scope.parentCallbacks.cardTypeSelected(type);
                    };
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/add-card/selectcard/directive.js
 ** module id = 282
 ** module chunks = 1
 **/